import React from 'react'
import PropTypes from 'prop-types'
import { useCallback } from 'sb-hooks'
import { links, snowplow, constants } from 'common/helpers'
import { intlMessageShape } from 'sb-react-intl'

import Button from 'components/_new/Button/Button'

import messages from './messages'


const ResubscribeButton = (props) => {
  const {
    className, placement, onClick, title, to, uppercase,
    size, color, weight, fullWidth, rightIcon, dataTestId,
  } = props

  const handleClick = useCallback((event) => {
    snowplow.track(constants.snowplowEvents.resubscribeClick, {
      placement,
    })

    if (typeof onClick === 'function') {
      onClick(event)
    }
  }, [ placement, onClick ])

  return (
    <Button
      className={className}
      title={title}
      to={to}
      size={size}
      color={color}
      fullWidth={fullWidth}
      weight={weight}
      rightIcon={rightIcon}
      uppercase={uppercase}
      dataTestId={dataTestId}
      onClick={handleClick}
    />
  )
}

ResubscribeButton.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  weight: PropTypes.string,
  uppercase: PropTypes.bool,
  title: PropTypes.shape(intlMessageShape),
  to: PropTypes.string,
  fullWidth: PropTypes.bool,
  rightIcon: PropTypes.bool,
  dataTestId: PropTypes.string,
  placement: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
}

ResubscribeButton.defaultProps = {
  size: 'md',
  color: 'brand',
  weight: 'medium',
  uppercase: true,
  title: messages.title,
  to: links.resubscribe,
  dataTestId: 'resubscribeButton',
}


export default ResubscribeButton
